// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__JM4B_","addWidgetButton":"Header_addWidgetButton__3cv_C","dashboardTabs":"Header_dashboardTabs__1EcXC","active":"Header_active__3MC2n"};